// Plain-language labels for application statuses (values mirror the backend enum).
export const APPLICATION_STATUS_LABELS = {
  draft: 'Not sent',
  invited: 'Invited',
  started: 'In progress',
  submitted: 'Submitted',
  verification_in_progress: 'Being verified',
  more_info_required: 'More information needed',
  report_ready: 'Report ready',
  decision_recorded: 'Decision made',
  disputed: 'Under dispute',
  closed: 'Closed',
  deletion_pending: 'Deletion pending',
  deleted: 'Deleted'
};

export const statusLabel = (status) => APPLICATION_STATUS_LABELS[status] || status;

// Reason codes as configured on the server (config/tenantverify.php).
export const REASON_CODE_LABELS = {
  AFF001: 'Affordability criteria not met',
  CRE002: 'Credit profile unacceptable',
  REF001: 'Unfavourable references received',
  INC001: 'Income unverifiable',
  ID001: 'Identity could not be verified'
};

export const OUTCOME_LABELS = {
  approve: 'Approved',
  decline: 'Declined',
  shortlist: 'Shortlisted',
  request_information: 'More information requested'
};
